var ActionNames;

ActionNames = require('./ActionNames');

module.exports = {
  markerAdded: function(marker) {
    return {
      type: ActionNames.MarkerAdded,
      marker: marker
    };
  },
  markerRemoved: function(marker) {
    return {
      type: ActionNames.MarkerRemoved,
      marker: marker
    };
  },
  markerMoved: function(marker) {
    return {
      type: ActionNames.MarkerMoved,
      marker: marker
    };
  },
  apiLoaded: function(apiLoaded) {
    return {
      type: ActionNames.ApiLoaded,
      apiLoaded: apiLoaded
    };
  },
  centreChanged: function(centre) {
    return {
      type: ActionNames.CentreChanged,
      centre: centre
    };
  },
  placesChanged: function(places) {
    return {
      type: ActionNames.PlacesChanged,
      places: places
    };
  }
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3dvcmsvc3JjL3N0YXRlL0FjdGlvbkZhY3Rvcmllcy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvd29yay9zcmMvc3RhdGUvQWN0aW9uRmFjdG9yaWVzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLFdBQUEsR0FBYyxPQUFBLENBQVEsZUFBUjs7QUFFZCxNQUFNLENBQUMsT0FBUCxHQUFpQjtFQUNoQixXQUFBLEVBQWEsU0FBQyxNQUFEO1dBQVk7TUFDeEIsSUFBQSxFQUFNLFdBQVcsQ0FBQyxXQURNO01BRXhCLFFBQUEsTUFGd0I7O0VBQVosQ0FERztFQUtoQixhQUFBLEVBQWUsU0FBQyxNQUFEO1dBQVk7TUFDMUIsSUFBQSxFQUFNLFdBQVcsQ0FBQyxhQURRO01BRTFCLFFBQUEsTUFGMEI7O0VBQVosQ0FMQztFQVNoQixXQUFBLEVBQWEsU0FBQyxNQUFEO1dBQVk7TUFDeEIsSUFBQSxFQUFNLFdBQVcsQ0FBQyxXQURNO01BRXhCLFFBQUEsTUFGd0I7O0VBQVosQ0FURztFQWFoQixTQUFBLEVBQVcsU0FBQyxTQUFEO1dBQWU7TUFDekIsSUFBQSxFQUFNLFdBQVcsQ0FBQyxTQURPO01BRXpCLFdBQUEsU0FGeUI7O0VBQWYsQ0FiSztFQWlCaEIsYUFBQSxFQUFlLFNBQUMsTUFBRDtXQUFZO01BQzFCLElBQUEsRUFBTSxXQUFXLENBQUMsYUFEUTtNQUUxQixRQUFBLE1BRjBCOztFQUFaLENBakJDO0VBcUJoQixhQUFBLEVBQWUsU0FBQyxNQUFEO1dBQVk7TUFDMUIsSUFBQSxFQUFNLFdBQVcsQ0FBQyxhQURRO01BRTFCLFFBQUEsTUFGMEI7O0VBQVosQ0FyQkMifQ==
